import { gql } from '@apollo/client'

const sendMagicLinkEmailMutation = gql`
  mutation useSendMagicLinkEmail($email: String!) {
    sendMagicLinkEmail(email: $email) {
      result
      errors {
        identifier
        message
        field
      }
    }
  }
`

export default sendMagicLinkEmailMutation
